import translations from './translations';
import { supportedLocales } from './config';

export default (defaultLocale: string) => {
  const navigatorLocale = window.navigator.language;
  const locale = (supportedLocales.includes(navigatorLocale) && navigatorLocale) || defaultLocale;
  const detectedLang = locale.split('-')[0];
  const lang =
    (supportedLocales.includes(detectedLang) && detectedLang) || defaultLocale.split('-')[0];
  const trs: { [index: string]: any } = translations;

  return {
    locale,
    lang,
    messages: trs[lang],
  };
};
